import React, { PureComponent } from 'react'

import Loader from 'components/ui/Loader/Loader'

import s from './LoadContainer.scss'


class LoadContainer extends PureComponent {

  state = {
    isMount: false,
  }

  componentDidMount() {
    this.setState({ isMount: true })
  }

  render() {
    const { isMount } = this.state
    const { children } = this.props

    return (
      <div className={s.container}>
        {
          isMount ? (
            children
          ) : (
            <Loader />
          )
        }
      </div>
    )
  }
}


export default LoadContainer
